import { render, staticRenderFns } from "./Unit4PNG.vue?vue&type=template&id=2a1b9cd1&scoped=true&"
import script from "./Unit4PNG.vue?vue&type=script&lang=js&"
export * from "./Unit4PNG.vue?vue&type=script&lang=js&"
import style0 from "./Unit4PNG.vue?vue&type=style&index=0&id=2a1b9cd1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b9cd1",
  null
  
)

export default component.exports